export default "__VITE_ASSET__iAP40Q6q__"